import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";

@Component({
  selector: "app-risk-project-sampling",
  templateUrl: "./risk-project-sampling.component.html",
  styleUrls: ["./risk-project-sampling.component.scss"],
})

export class RiskProjectSamplingComponent implements OnInit {


@Input() isRiskProject: boolean;
@Input() overreadIProjectEnabled: any;
@Input() overreadIIProjectEnabled: any;
@Input() overreadIProjectValue: any;
@Input() overreadIIProjectValue: any;
@Input() riskFormGroup: FormGroup;
@Input() projectConfigForm: FormGroup;
@Input() trackByIndex: (index: number, obj: any) => any;
@Output() deficientChaseBlur = new EventEmitter<{ group: string; index: number }>();

constructor() { }


get overread1Description(): string {
   return "This setting initiates review on first-pass coding.";
  }
get overread2Description(): string {
    return "This setting enables secondary review which occurs Overread I";
   }

ngOnInit(): void {
  }

}
